import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { ErrorMessageHelper } from '@rd/helpers/error-message.helper';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupSettingService } from '@rd/popup/services/popup-setting/popup-setting.service';
import { ButtonTheme, CheckoutErrorDialogConfig } from '@rd/types';

@Component({
  selector: 'rd-shared-checkout-error-dialog',
  templateUrl: './checkout-error-dialog.component.html',
  styleUrls: ['./checkout-error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckoutErrorDialogComponent implements OnInit {
  @HostBinding('class.rd-shared-checkout-error-dialog') componentClass = true;

  constructor(
    private dialogRef: DialogRef,
    private errorMessageHelper: ErrorMessageHelper,
    private iconRegistryService: IconRegistryService,
    private popupSettingService: PopupSettingService,
    public dialogConfig: DialogConfig<CheckoutErrorDialogConfig>,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
    this.setErrorMessage();
  }

  get buttonTheme(): ButtonTheme {
    return this.popupSettingService.singleButtonTheme;
  }

  get shouldRenderCheckoutErrorDialogTitle(): boolean {
    return (
      this.popupSettingService.shouldRenderCheckoutErrorDialogTitle &&
      // @ts-ignore
      this.dialogConfig.data.errorMessageTitle !== ''
    );
  }

  handleClick(): void {
    this.dialogRef.close();
  }

  registerIcons(): void {
    // @ts-ignore
    const iconName = this.dialogConfig.data.iconName || 'failed';
    this.iconRegistryService.registerIcon(iconName);
  }

  getIconSymbol(): string {
    // @ts-ignore
    const iconSymbol = this.dialogConfig.data.iconName || 'failed';
    return `icon-${iconSymbol}`;
  }

  private setErrorMessage(): void {
    // @ts-ignore
    if (this.dialogConfig.data.error) {
      /* eslint-disable @typescript-eslint/no-unused-expressions */
      // @ts-ignore
      this.dialogConfig.data.ctaButtonText ||=
        this.errorMessageHelper.getDialogCtaText(
          // @ts-ignore
          this.dialogConfig.data.error,
        );
      // @ts-ignore
      this.dialogConfig.data.errorMessageDescription ||=
        this.errorMessageHelper.getErrorDescription(
          // @ts-ignore
          this.dialogConfig.data.error,
          this.dialogConfig.data?.interpolateData,
        );
      // @ts-ignore
      this.dialogConfig.data.errorMessageTitle ||=
        this.errorMessageHelper.getErrorTitle(
          // @ts-ignore
          this.dialogConfig.data.error,
        );
      /* eslint-enable @typescript-eslint/no-unused-expressions */
    }
  }
}
